import script from "./CarouselPersonalizado.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselPersonalizado.vue?vue&type=script&setup=true&lang=js"

import "./CarouselPersonalizado.vue?vue&type=style&index=0&id=548b3325&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-548b3325"]])

export default __exports__